import { Component } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';



import { PessoalService } from '../../../../providers/pessoal-service';
import { AlertService } from '../../../../providers/alert-service';
import { MenuService } from '../../../../providers/menu-service';
import { ModulosController } from '../../modulos-controller';
import { UsuarioService } from '../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../providers/gestao-pca-service';

@Component({
    selector: 'page-quadro-pessoal',
    templateUrl: 'quadro-pessoal.html',
    providers: [
        PessoalService
    ]
})
export class PessoalQuadroPessoalPage extends ModulosController {
    listaDados: any = [];
    listaDadosAux: any = [];
    loading: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "107";
    flTipo: any = "cargo";

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public pessoalService: PessoalService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
        this.carregarDados();
        this.setModuloId(11);
        this.setIdModuloPca(this.navParams.get('analise').idModuloPca);
    }

    carregarDados() {
        this.pessoalService.obterQuadroPessoal().subscribe(data => {
            this.listaDados = data;
            this.listaDadosAux = data;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaPessoal() {
        this.menuService.redirecionarPagina(this.pessoalService.obterIdPaginaPessoal());
    }

    salvarFlagIncluir() {

        this.loading = true;
        this.listaDados.dsResumoAnalise = this.capitalize(this.listaDados.dsResumoAnalise);
        this.pessoalService.salvarQuadroPessoal(this.listaDados).subscribe(data => {
            this.alertService.mostraAlerta("", "Salvo com sucesso.");
            this.loading = false;
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
            this.loading = false;
        })
    }

    submeterNoCertificado() {
        let idAnalise = "";
        this.loading = true;
        if (this.listaDados.dsResumoAnalise == undefined || !this.listaDados.dsResumoAnalise || this.listaDados.dsResumoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.dsResumoAnalise == null) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
            this.loading = false;
        } else {
            if (this.listaDados) {
                idAnalise = this.listaDados.idModuloAnalise;
                this.listaDados.dsResumoAnalise = this.capitalize(this.listaDados.dsResumoAnalise);
                this.pessoalService.finalizarQuadroPessoal(this.listaDados).subscribe(data => {
                    this.alertService.mostraAlerta("", "Submetido com sucesso.");
                    this.voltarParaPessoal();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    this.loading = false;
                });
            }
        }
    }

    capitalize(str) {
        let retorno = "";
    
        if (str) {
          retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }
    
        return retorno;
      }

    somarInicioExercicio(item) {
        let val = 0;

        item[1].forEach(element => {
            val += +element.demonstrativo.inicioExercicio;
        });

        return val;
    }

    somarCriadosExercicio(item) {
        let val = 0;

        item[1].forEach(element => {
            val += +element.demonstrativo.criadosExercicio;
        });

        return val;
    }

    somarExtintosExercicio(item) {
        let val = 0;

        item[1].forEach(element => {
            val += +element.demonstrativo.extintosExercicio;
        });

        return val;
    }

    somarFinalExercicio(item) {
        let val = 0;

        item[1].forEach(element => {
            val += +element.demonstrativo.finalExercicio;
        });

        return val;
    }

    somarOcupadosInicioExercicio(item) {
        let val = 0;

        item[1].forEach(element => {
            val += +element.demonstrativo.ocupadosInicioExercicio;
        });

        return val;
    }

    somarNomeadosExercicio(item) {
        let val = 0;

        item[1].forEach(element => {
            val += +element.demonstrativo.nomeadosExercicio;
        });

        return val;
    }

    somarCargosExoneradosExercicio(item) {
        let val = 0;

        item[1].forEach(element => {
            val += +element.demonstrativo.cargosExoneradosExercicio;
        });

        return val;
    }

    somarOcupadosfinalExercicio(item) {
        let val = 0;

        item[1].forEach(element => {
            val += +element.demonstrativo.ocupadosfinalExercicio;
        });

        return val;
    }

    somarCargosVagosFinalExercicio(item) {
        let val = 0;

        item[1].forEach(element => {
            val += +element.demonstrativo.cargosVagosFinalExercicio;
        });

        return val;
    }

    checkFlCertificado(item) {
        let val = false;
        let contador = 0;

        item[1].forEach(element => {
            if (element.flCertificado) {
                contador++;
            }
        });

        if (contador == item[1].length) {
            val = true;
        }

        return val;
    }

    onCertificadoVinculoChange(item) {

        this.listaDados.analiseQuantitativoPessoal.forEach(element => {
            if (element.demonstrativo.vinculo.dsGrupoCargo == item[0]) {
                element.flCertificado = item[1][0].flCertificado;
            }
        });

        this.checkFlCertificado(item);
    }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/pessoal/quadro-pessoal/quadro-pessoal.ts